import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IAppState } from 'src/app/interfaces/app-state';
import { Store } from '@ngrx/store';
import { HttpService } from 'src/app/services/http/http.service';
import { Router } from '@angular/router';
import { BasePageComponent } from 'src/app/pages/base-page';
import { ResetPssService } from '../reset-form/reset-form.service';
import { MustMatch } from './must-match.validator';
import Swal from 'sweetalert2'
@Component({
  selector: 'reset-form',
  templateUrl: './reset-form.component.html',
  styleUrls: ['./reset-form.component.scss']
})
export class ResetFormComponent extends BasePageComponent implements OnInit, OnDestroy  {
  error_messages = {

    'password': [
      { type: 'required', message: 'password is required.' },
      { type: 'minlength', message: 'password length.' },
      { type: 'maxlength', message: 'password length.' }
    ],
    'confirmpassword': [
      { type: 'required', message: 'password is required.' },
      { type: 'minlength', message: 'password length.' },
      { type: 'maxlength', message: 'password length.' },
      { type: 'passwordNotMatch', message: "Password doesn't match" },
    ],
  }
  resetForm: FormGroup;
  resetFormLoad: boolean;
  mustMatch = false;
  code
  dataUrl
  token
  constructor(private fb: FormBuilder,private ResetPssService: ResetPssService,private router:Router,
    store: Store<IAppState>,
    httpSv: HttpService) { 
    super(store, httpSv);
    this.dataUrl = this.router.url;
    this.code = this.dataUrl.split('=');
    this.token=this.code[1]
  }

  ngOnInit() {
    
    this.resetForm = this.fb.group({
      password: ['', [Validators.required,Validators.minLength(6),Validators.maxLength(30)]],
      confirmpassword: ['',[Validators.required,Validators.minLength(6),Validators.maxLength(30)]],
    });
  }

  forgotFormSubmit(){
    if(this.resetForm.value.password !== this.resetForm.value.confirmpassword){
      this.mustMatch = true;
    } else{
      this.mustMatch = false;
      this.resetFormLoad = true;
      if(this.resetForm.invalid){
        return;
      }
      this.ResetPssService.postLogin(this.resetForm.value,this.token).subscribe(
        response => {
          if(response['status'] == true){
            Swal.fire("Password Successfully Changed")
            this.router.navigate(['/public/sign-in']);
            this.resetFormLoad = false;
          }
          else{
            this.resetFormLoad = false;
            Swal.fire("Something Went Wrong")
          }
      
        }
      )
    }
  }

  password(formGroup: FormGroup) {
    const { value: password } = formGroup.get('password');
    const { value: confirmPassword } = formGroup.get('confirmpassword');
    return password === confirmPassword ? null : { passwordNotMatch: true };
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
